<template>
    <div class="bar-charts-page">
        <div class="charts" ref="customCo"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: "BarCharts",
    props:{
        list: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return{
            // 适应分辨率
            // radio: document.documentElement.clientWidth / 1920,
            chartsList: [],
            myChart: null,
        }
    },
    mounted(){
        this.myChart = echarts.init(this.$refs.customCo);
        window.addEventListener("resize", this.handleWindowResize);
    },
    beforeDestroy(){
        // window.removeEventListener("resize", this.handleWindowResize);
    },
    methods:{
        // 数据改造
        createData(){
            let label = [];
            let data = [];
            if(this.chartsList.length != 0){
                this.chartsList.map(item => {
                    label.push(item.type);
                    data.push(item.value);
                });
            }
            if(this.myChart){
                this.initCharts(label, data);
            }
        },

        // 初始化 bar
        initCharts(label, data){
            const option = {
                tooltip:{
                    show: true,
                    trigger: 'axis',
                    axisPointer: {                              // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'                          // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: 'rgba(50,50,50,0.7)',
                    // formatter(params){
                    //     console.log(params, "params");
                    // },
                },
                grid: {
                    left: '-3%',
                    right: '4%',
                    bottom: '6%',
                    containLabel: true                          // grid 区域是否包含坐标轴的刻度标签。
                },
                xAxis: [{
                    type: 'category',
                    data: label,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(255,255,255,0)'
                        }
                    },
                    axisLabel: {                                // 坐标轴刻度标签的相关设置
                        color: '#B8D1D2',
                        fontSize: 12,
                        width: 25,
                        interval: 0,
                        overflow: 'break',
                        lineHeight: 16
                    },
                }],
                yAxis: [{
                    axisLine: {                                 // 坐标轴轴线相关设置
                        show: false,
                        lineStyle: {
                            color: 'rgba(255,255,255,0)'
                        }
                    },
                    splitLine: {                                // 坐标轴在 grid 区域中的分隔线。
                        show: false,
                        lineStyle: {
                            color: 'rgba(255,255,255,0)'
                        }
                    }
                }],
                series: [{
                    type: 'bar',
                    data: data,
                    barWidth: '20',
                    showBackground: false,
                    // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。
                    // label: {
                    //     show: true,
                    //     position: 'top',
                    //     // formatter(params){
                    //     //     console.log(params, "params");
                    //     // }
                    // },
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        //前四个参数用于配置渐变色的起止位置，这四个参数依次对应 右下左上 四个方位。也就是从右边开始顺时针方向。
                        //通过修改前4个参数，可以实现不同的渐变方向
                        /*第五个参数则是一个数组，用于配置颜色的渐变过程。
                          每项为一个对象，包含offset和color两个参数
                        */
                            offset: 0,
                            color: 'rgba(10, 233, 232, 1)' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: 'rgba(248, 204, 193, 1)' // 100% 处的颜色
                        }]),
                        borderRadius: [30, 30, 30, 30],
                        shadowColor: 'rgba(0,160,221,0)',
                        shadowBlur: 4,
                    }
                }]
            };

            this.myChart.setOption(option);
        },

        // 自动调整 echarts 的大小
        handleWindowResize(){
            if(!this.myChart) return;
            this.myChart.resize();
        }
    },
    watch: {
        'list': {
            immediate: true,
            handler(value){
                // console.log(value);
                this.chartsList = value;
                this.$nextTick(function (){
                    this.createData();
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bar-charts-page{
    display: flex;
    width: 100%;
    height: 100%;
    background-color: cornflowerblue;
    .charts{
        flex:1;
    }
}
</style>